<div
  class="main-content move-business"
  [attr.aria-busy]="loading || businessesLoading"
>
  <header class="page-heading">
    <h1>{{ "MOVE_BUSINESS" | translate }}</h1>
    <p *ngIf="step === 0">
      {{
        "MOVE_BUSINESS_FLOW.SUBTITLE"
          | translate: { platform: sourcePlatformName }
      }}
    </p>
  </header>

  <ol
    class="move-steps"
    *ngIf="step < 3 && !error"
    [attr.aria-label]="'MOVE_BUSINESS_FLOW.PROGRESS' | translate"
  >
    <li
      *ngFor="
        let label of ['BUSINESSES', 'DESTINATION', 'REVIEW'];
        let i = index
      "
      [class.current]="step === i"
      [class.complete]="step > i"
      [attr.aria-current]="step === i ? 'step' : null"
    >
      <span class="step-number"
        ><i *ngIf="step > i" class="pi pi-check" aria-hidden="true"></i
        ><ng-container *ngIf="step <= i">{{ i + 1 }}</ng-container></span
      >
      {{ "MOVE_BUSINESS_FLOW." + label | translate }}
    </li>
  </ol>

  <section *ngIf="error" class="move-error" role="alert">
    <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
    <div>
      <h2>
        {{
          (uncertain
            ? "MOVE_BUSINESS_FLOW.STATUS_UNKNOWN"
            : "MOVE_BUSINESS_FLOW.NOTHING_MOVED"
          ) | translate
        }}
      </h2>
      <p>{{ error }}</p>
      <button
        class="btn btn-primary"
        type="button"
        [disabled]="loading"
        (click)="reload()"
      >
        <i class="pi pi-refresh" aria-hidden="true"></i
        >{{ "MOVE_BUSINESS_FLOW.RELOAD" | translate }}
      </button>
    </div>
  </section>

  <section *ngIf="step === 0 && !error" class="move-card business-selection">
    <div class="move-filters">
      <div class="search-field">
        <label for="business-search">{{ "Search" | translate }}</label>
        <div class="search-input">
          <i class="pi pi-search" aria-hidden="true"></i>
          <input
            id="business-search"
            pInputText
            [(ngModel)]="search"
            (ngModelChange)="filtersChanged(true)"
            type="search"
            maxlength="200"
            [placeholder]="'MOVE_BUSINESS_FLOW.SEARCH_HINT' | translate"
          />
        </div>
      </div>
      <div class="owner-filter">
        <label for="source-owner">{{
          "MOVE_BUSINESS_FLOW.CURRENT_OWNER" | translate
        }}</label>
        <p-select
          inputId="source-owner"
          [(ngModel)]="sourceFilter"
          [options]="sourceOwners"
          [loading]="sourceOwnersLoading"
          [disabled]="sourceOwnersLoading"
          (onChange)="filtersChanged()"
          optionLabel="Name"
          [showClear]="true"
          [filter]="true"
          [placeholder]="'MOVE_BUSINESS_FLOW.ALL_OWNERS' | translate"
        >
          <ng-template pTemplate="item" let-owner>{{
            ownerLabel(owner)
          }}</ng-template>
          <ng-template pTemplate="selectedItem" let-owner>{{
            ownerLabel(owner)
          }}</ng-template>
        </p-select>
      </div>
      <label class="inline-check" for="includeInactive">
        <p-checkbox
          [(ngModel)]="includeInactive"
          [binary]="true"
          inputId="includeInactive"
          (onChange)="filtersChanged()"
        ></p-checkbox>
        {{ "MOVE_BUSINESS_FLOW.INCLUDE_INACTIVE" | translate }}
      </label>
    </div>
    <p-table
      [value]="businesses"
      [selection]="selected"
      (selectionChange)="selectionChanged($event)"
      [selectionPageOnly]="true"
      dataKey="Id"
      [paginator]="true"
      [rows]="pageSize"
      [first]="first"
      [totalRecords]="totalBusinesses"
      [lazy]="true"
      [lazyLoadOnInit]="false"
      (onLazyLoad)="pageChanged($event)"
      [loading]="loading || businessesLoading"
      [tableStyle]="{ 'min-width': '48rem' }"
    >
      <ng-template pTemplate="header"
        ><tr>
          <th class="selection-column">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th>{{ "COMPANY" | translate }}</th>
          <th>{{ "MOVE_BUSINESS_FLOW.ORGANIZATION" | translate }}</th>
          <th>{{ "MOVE_BUSINESS_FLOW.CURRENT_OWNER" | translate }}</th>
          <th>{{ "Status" | translate }}</th>
        </tr></ng-template
      >
      <ng-template pTemplate="body" let-business
        ><tr>
          <td><p-tableCheckbox [value]="business"></p-tableCheckbox></td>
          <td>
            <strong>{{ business.CompanyName }}</strong>
            <span class="business-id">#{{ business.Id }}</span>
          </td>
          <td class="organization-number">{{ business.OrganizationNumber }}</td>
          <td>
            <div class="owner-cell">
              <span
                class="owner-badge"
                [class.portal-badge]="business.PortalId"
              >
                {{
                  (business.PortalId
                    ? "MOVE_BUSINESS_FLOW.PORTAL"
                    : "MOVE_BUSINESS_FLOW.ADMIN"
                  ) | translate
                }}
                ({{ sourcePlatformName }}) </span
              ><span>{{ business.OwnerName }}</span>
            </div>
          </td>
          <td>
            <span
              class="business-status"
              [class.inactive]="business.Status !== 1"
            >
              {{
                (business.Status === 1
                  ? "MOVE_BUSINESS_FLOW.ACTIVE"
                  : "MOVE_BUSINESS_FLOW.INACTIVE"
                ) | translate
              }}
            </span>
          </td>
        </tr></ng-template
      >
      <ng-template pTemplate="emptymessage"
        ><tr>
          <td colspan="5">{{ "NO_RECORDS_FOUND" | translate }}</td>
        </tr></ng-template
      >
    </p-table>
    <footer class="selection-footer">
      <div class="selection-count" aria-live="polite">
        <strong>{{
          "MOVE_BUSINESS_FLOW.SELECTED" | translate: { count: selected.length }
        }}</strong
        ><span *ngIf="selected.length"> · {{ sourceNames }}</span>
      </div>
      <button
        class="btn btn-link"
        type="button"
        (click)="clearSelection()"
        [disabled]="selected.length === 0"
      >
        {{ "MOVE_BUSINESS_FLOW.CLEAR" | translate }}
      </button>
      <button
        class="btn btn-primary next"
        type="button"
        (click)="chooseDestination()"
        [disabled]="
          loading ||
          businessesLoading ||
          selected.length === 0 ||
          selected.length > 20
        "
      >
        {{ "MOVE_BUSINESS_FLOW.NEXT_DESTINATION" | translate
        }}<i class="pi pi-arrow-right" aria-hidden="true"></i>
      </button>
      <p *ngIf="selected.length > 20" class="batch-limit" role="alert">
        {{ "MOVE_BUSINESS_FLOW.BATCH_LIMIT" | translate }}
      </p>
    </footer>
  </section>

  <section *ngIf="step === 1 && !error" class="move-stage">
    <div class="selection-summary move-card">
      <i class="pi pi-building" aria-hidden="true"></i>
      <div>
        <strong>{{
          "MOVE_BUSINESS_FLOW.MOVING_COUNT"
            | translate: { count: selected.length }
        }}</strong>
        <span>
          {{ "MOVE_BUSINESS_FLOW.FROM" | translate }}
          <strong>{{ sourceNames }}</strong
          >: {{ selectedNames }}</span
        >
      </div>
      <button
        class="btn btn-link"
        type="button"
        (click)="step = 0; invalidatePreview()"
        [disabled]="loading"
      >
        {{ "MOVE_BUSINESS_FLOW.CHANGE" | translate }}
      </button>
    </div>
    <div class="move-card card-content">
      <fieldset class="destination-options">
        <legend>{{ "MOVE_BUSINESS_FLOW.MOVE_TO" | translate }}</legend>
        <div class="destination-choices">
          <label
            class="destination-choice"
            [class.chosen]="destinationKind === 'admin'"
          >
            <input
              type="radio"
              name="destination-kind"
              [checked]="destinationKind === 'admin'"
              (change)="changeDestinationKind('admin')"
              [disabled]="loading"
            />
            <span
              ><strong
                >{{ "MOVE_BUSINESS_FLOW.ADMIN" | translate }} ({{
                  sourcePlatformName
                }})</strong
              ><small>{{
                "MOVE_BUSINESS_FLOW.ADMIN_HINT" | translate
              }}</small></span
            >
          </label>
          <label
            class="destination-choice"
            [class.chosen]="destinationKind === 'portal'"
          >
            <input
              type="radio"
              name="destination-kind"
              [checked]="destinationKind === 'portal'"
              (change)="changeDestinationKind('portal')"
              [disabled]="loading"
            />
            <span
              ><strong
                >{{ "MOVE_BUSINESS_FLOW.PORTAL" | translate }} ({{
                  sourcePlatformName
                }})</strong
              ><small>{{
                "MOVE_BUSINESS_FLOW.PORTAL_HINT" | translate
              }}</small></span
            >
          </label>
          <label
            class="destination-choice"
            [class.chosen]="destinationKind === 'application'"
            [class.unavailable]="!canChangeApplication"
          >
            <input
              type="radio"
              name="destination-kind"
              [checked]="destinationKind === 'application'"
              (change)="changeDestinationKind('application')"
              [disabled]="loading || !canChangeApplication"
            />
            <span
              ><strong>{{
                "MOVE_BUSINESS_FLOW.OTHER_APPLICATION" | translate
              }}</strong
              ><small>{{
                (otherPlatforms.length === 0
                  ? "MOVE_BUSINESS_FLOW.PLATFORM_UNAVAILABLE"
                  : selected.length !== 1
                    ? "MOVE_BUSINESS_FLOW.CROSS_PLATFORM_LIMIT"
                    : !canChangeApplication
                      ? "MOVE_BUSINESS_FLOW.DETACH_PORTAL_FIRST"
                      : "MOVE_BUSINESS_FLOW.APPLICATION_HINT"
                ) | translate
              }}</small></span
            >
          </label>
        </div>
      </fieldset>
      <div class="destination-fields">
        <div *ngIf="destinationKind === 'application'">
          <label for="target-platform"
            >{{ "MOVE_BUSINESS_FLOW.PLATFORM" | translate }}
            <span class="required" aria-hidden="true">*</span></label
          >
          <p-select
            inputId="target-platform"
            [(ngModel)]="targetApplicationId"
            [options]="otherPlatforms"
            optionLabel="Name"
            optionValue="Id"
            (onChange)="loadOwners()"
            [disabled]="loading"
          ></p-select>
        </div>
        <div>
          <label for="destination-owner"
            >{{
              (destinationKind === "portal"
                ? "MOVE_BUSINESS_FLOW.PORTAL"
                : "MOVE_BUSINESS_FLOW.ADMIN"
              ) | translate
            }}
            <span class="required" aria-hidden="true">*</span></label
          >
          <p-select
            inputId="destination-owner"
            [(ngModel)]="destination"
            [options]="availableOwners"
            optionLabel="Name"
            [filter]="true"
            [loading]="ownersLoading"
            [disabled]="loading || ownersLoading"
            (onChange)="ownerChanged()"
            [placeholder]="'SELECT_DROPDOWN.SELECT' | translate"
          >
            <ng-template pTemplate="item" let-owner>{{
              ownerLabel(owner)
            }}</ng-template>
            <ng-template pTemplate="selectedItem" let-owner>{{
              ownerLabel(owner)
            }}</ng-template>
          </p-select>
          <small class="field-hint">{{
            "MOVE_BUSINESS_FLOW.OWNER_HINT" | translate
          }}</small>
        </div>
      </div>
      <div class="move-info" *ngIf="crossPlatform">
        <i class="pi pi-info-circle" aria-hidden="true"></i>
        <p>{{ "MOVE_BUSINESS_FLOW.IMPACT_HINT" | translate }}</p>
      </div>
      <section
        class="portal-access"
        *ngIf="destination?.BusinessPortalId"
        [attr.aria-busy]="usersLoading"
      >
        <div class="section-heading">
          <h2>
            {{
              "MOVE_BUSINESS_FLOW.PORTAL_ACCESS"
                | translate: { portal: destination?.Name }
            }}
          </h2>
          <button
            class="btn btn-link"
            type="button"
            (click)="selectAllUsers()"
            [disabled]="loading || usersLoading"
          >
            {{ "MOVE_BUSINESS_FLOW.SELECT_ALL" | translate }}
          </button>
          <button
            class="btn btn-link"
            type="button"
            (click)="clearUsers()"
            [disabled]="loading || usersLoading"
          >
            {{ "MOVE_BUSINESS_FLOW.CLEAR" | translate }}
          </button>
        </div>
        <p class="field-hint">
          {{ "MOVE_BUSINESS_FLOW.ACCESS_CHANGE" | translate }}
        </p>
        <p *ngIf="usersLoading" role="status">{{ "PROCESSING" | translate }}</p>
        <div class="portal-users" *ngIf="!usersLoading">
          <div class="portal-user manager-row">
            <i class="pi pi-lock" aria-hidden="true"></i
            ><strong *ngIf="portalManager">{{ portalManager.Name }}</strong>
            <span class="owner-badge portal-badge">{{
              "MOVE_BUSINESS_FLOW.MANAGER" | translate
            }}</span>
            <small>{{ "MOVE_BUSINESS_FLOW.MANAGER_HINT" | translate }}</small>
          </div>
          <label
            *ngFor="let user of optionalPortalUsers"
            class="portal-user"
            [for]="'portal-user-' + user.Id"
          >
            <p-checkbox
              [inputId]="'portal-user-' + user.Id"
              [value]="user.Id"
              [(ngModel)]="selectedPortalUsers"
              [disabled]="loading"
              (onChange)="invalidatePreview()"
            ></p-checkbox>
            <span>{{ user.Name }}</span>
          </label>
        </div>
      </section>
    </div>
    <footer>
      <button
        class="btn btn-secondary"
        type="button"
        (click)="step = 0; invalidatePreview()"
        [disabled]="loading"
      >
        {{ "MOVE_BUSINESS_FLOW.BACK" | translate }}
      </button>
      <span
        class="user-count"
        *ngIf="destination?.BusinessPortalId"
        aria-live="polite"
        >{{
          "MOVE_BUSINESS_FLOW.USERS_SELECTED"
            | translate
              : {
                  count: selectedPortalUsers.length,
                  total: optionalPortalUsers.length
                }
        }}</span
      >
      <button
        class="btn btn-primary next"
        type="button"
        (click)="review()"
        [disabled]="!canReview"
      >
        {{
          (crossPlatform
            ? "MOVE_BUSINESS_FLOW.NEXT_IMPACT"
            : "MOVE_BUSINESS_FLOW.NEXT_REVIEW"
          ) | translate
        }}<i class="pi pi-arrow-right" aria-hidden="true"></i>
      </button>
    </footer>
  </section>

  <section *ngIf="step === 2 && preview as report" class="move-stage">
    <div class="move-card card-content">
      <div class="review-destination">
        <div class="destination-summary">
          <small>{{ "MOVE_BUSINESS_FLOW.FROM" | translate }}</small
          ><strong>{{ sourceNames }}</strong
          ><span>{{ sourcePlatformName }}</span>
        </div>
        <i class="pi pi-arrow-right" aria-hidden="true"></i>
        <div class="destination-summary chosen">
          <small>{{ "MOVE_BUSINESS_FLOW.TO" | translate }}</small
          ><strong>{{ destination?.Name }}</strong
          ><span
            >{{
              (destination?.BusinessPortalId
                ? "MOVE_BUSINESS_FLOW.PORTAL"
                : "MOVE_BUSINESS_FLOW.ADMIN"
              ) | translate
            }}
            ({{ targetPlatformName }})</span
          >
        </div>
        <span class="review-count">{{
          "MOVE_BUSINESS_FLOW.BUSINESS_COUNT"
            | translate: { count: report.Businesses.length }
        }}</span>
      </div>
      <div class="table-scroll">
        <table class="impact-table">
          <thead>
            <tr>
              <th>{{ "COMPANY" | translate }}</th>
              <th>{{ "MOVE_BUSINESS_FLOW.ORGANIZATION" | translate }}</th>
              <th>{{ "MOVE_BUSINESS_FLOW.NEEDS_ATTENTION" | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let business of report.Businesses">
              <td>
                <strong>{{ business.CompanyName }}</strong>
              </td>
              <td class="organization-number">
                {{ business.OrganizationNumber }}
              </td>
              <td>
                <ul
                  class="attention-list"
                  *ngIf="warningsFor(business.Id).length; else noWarnings"
                >
                  <li *ngFor="let warning of warningsFor(business.Id)">
                    {{
                      "MOVE_BUSINESS_FLOW.ATTENTION_" + warning.Code
                        | translate
                    }}<span *ngIf="warning.Detail">: {{ warning.Detail }}</span>
                  </li>
                </ul>
                <ng-template #noWarnings>{{
                  "MOVE_BUSINESS_FLOW.NONE" | translate
                }}</ng-template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <section class="what-happens">
        <h2>{{ "MOVE_BUSINESS_FLOW.WHAT_HAPPENS" | translate }}</h2>
        <p>
          {{
            "MOVE_BUSINESS_FLOW.NEW_OWNER"
              | translate: { destination: destination?.Name }
          }}
        </p>
        <div class="access-summary">
          <div>
            <h3>{{ "MOVE_BUSINESS_FLOW.LOSES_ACCESS" | translate }}</h3>
            <p *ngFor="let user of report.LosingAccess">{{ user.Name }}</p>
            <p *ngIf="report.LosingAccess.length === 0">
              {{ "MOVE_BUSINESS_FLOW.NONE" | translate }}
            </p>
          </div>
          <div>
            <h3>{{ "MOVE_BUSINESS_FLOW.GETS_ACCESS" | translate }}</h3>
            <p *ngFor="let user of report.GainingAccess">{{ user.Name }}</p>
            <p *ngIf="report.GainingAccess.length === 0">
              {{ "MOVE_BUSINESS_FLOW.NONE" | translate }}
            </p>
          </div>
        </div>
        <p>{{ "MOVE_BUSINESS_FLOW.OWN_USERS_UNCHANGED" | translate }}</p>
        <p>
          {{
            "MOVE_BUSINESS_FLOW.SIGN_OUT"
              | translate: { count: report.SessionsInvalidatedForUsers }
          }}
        </p>
      </section>
      <section class="move-warning" *ngIf="report.Warnings.length">
        <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
        <div>
          <h2>{{ "MOVE_BUSINESS_FLOW.WARNINGS" | translate }}</h2>
          <ul>
            <li *ngFor="let warning of report.Warnings">
              <strong>{{ businessName(warning.BusinessId) }}:</strong>
              {{ "MOVE_BUSINESS_FLOW.WARN_" + warning.Code | translate }}
              <span *ngIf="warning.Detail">{{ warning.Detail }}</span>
            </li>
          </ul>
        </div>
      </section>
      <details *ngIf="report.Tables.length">
        <summary>{{ "MOVE_BUSINESS_FLOW.ROW_COUNTS" | translate }}</summary>
        <div class="table-scroll">
          <table class="impact-table">
            <thead>
              <tr>
                <th>{{ "MOVE_BUSINESS_FLOW.DATA" | translate }}</th>
                <th>{{ "MOVE_BUSINESS_FLOW.ROWS" | translate }}</th>
                <th>{{ "Status" | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let table of report.Tables">
                <td>{{ table.Schema }}.{{ table.Table }}</td>
                <td>{{ table.Rows }}</td>
                <td>
                  {{
                    (table.Skipped
                      ? "MOVE_BUSINESS_FLOW.SKIPPED"
                      : "MOVE_BUSINESS_FLOW.MOVING"
                    ) | translate
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </details>
      <label
        class="confirmation-number"
        *ngIf="crossPlatform"
        for="organization-confirmation"
        >{{
          "MOVE_BUSINESS_FLOW.CONFIRM_ORG"
            | translate: { number: confirmationNumber }
        }}
        <input
          id="organization-confirmation"
          pInputText
          [(ngModel)]="organizationConfirmation"
          [disabled]="loading"
          autocomplete="off"
        />
      </label>
      <label class="inline-check acknowledgment" for="acknowledged"
        ><p-checkbox
          [(ngModel)]="acknowledged"
          [binary]="true"
          [disabled]="loading"
          inputId="acknowledged"
        ></p-checkbox
        >{{
          "MOVE_BUSINESS_FLOW.ACKNOWLEDGE"
            | translate: { count: selected.length }
        }}</label
      >
    </div>
    <footer>
      <button
        class="btn btn-secondary"
        type="button"
        (click)="step = 1; invalidatePreview()"
        [disabled]="loading"
      >
        {{ "MOVE_BUSINESS_FLOW.BACK" | translate }}
      </button>
      <button
        class="btn btn-primary next"
        type="button"
        (click)="commit()"
        [disabled]="!canCommit"
      >
        {{
          "MOVE_BUSINESS_FLOW.CONFIRM_MOVE"
            | translate: { count: selected.length }
        }}
      </button>
    </footer>
  </section>

  <section
    *ngIf="step === 3 && result as completed"
    class="move-card move-complete"
    role="status"
  >
    <div class="completion-heading">
      <span class="success-icon"
        ><i class="pi pi-check" aria-hidden="true"></i
      ></span>
      <div>
        <h2>
          {{
            "MOVE_BUSINESS_FLOW.COMPLETED"
              | translate
                : {
                    count: completed.Businesses.length,
                    destination: destination?.Name
                  }
          }}
          ({{ targetPlatformName }})
        </h2>
        <p>
          {{
            "MOVE_BUSINESS_FLOW.SIGNED_OUT"
              | translate: { count: completed.SessionsInvalidatedForUsers }
          }}
          <span>{{ completed.CompletedAt | date: "medium" }}</span>
        </p>
      </div>
    </div>
    <ul class="moved-businesses">
      <li *ngFor="let business of completed.Businesses">
        <strong>{{ business.CompanyName }}</strong
        ><span
          >{{ sourceOwnerName(business.Id) }}
          <i class="pi pi-arrow-right" aria-hidden="true"></i>
          {{ destination?.Name }}</span
        >
        <a
          *ngIf="!crossPlatform"
          [routerLink]="['../business/edit', business.Id, 'details']"
          >{{ "MOVE_BUSINESS_FLOW.OPEN_BUSINESS" | translate
          }}<span class="sr-only">: {{ business.CompanyName }}</span></a
        >
      </li>
    </ul>
    <section class="move-warning" *ngIf="followUpWarnings.length">
      <i class="pi pi-info-circle" aria-hidden="true"></i>
      <div>
        <h3>{{ "MOVE_BUSINESS_FLOW.FOLLOW_UP" | translate }}</h3>
        <ul>
          <li *ngFor="let warning of followUpWarnings">
            <strong>{{ businessName(warning.BusinessId) }}:</strong>
            {{ "MOVE_BUSINESS_FLOW.WARN_" + warning.Code | translate }}
            <span *ngIf="warning.Detail">{{ warning.Detail }}</span>
          </li>
        </ul>
      </div>
    </section>
    <p class="move-reference">
      {{ "MOVE_BUSINESS_FLOW.RUN_ID" | translate }}: {{ completed.RunId }}
    </p>
    <div>
      <button class="btn btn-primary" type="button" (click)="reload()">
        {{ "MOVE_BUSINESS_FLOW.MOVE_MORE" | translate }}
      </button>
    </div>
  </section>
</div>
<kuba-busy [busy]="loading" message="PROCESSING"></kuba-busy>
